import { render, staticRenderFns } from "./SupplierManageMaterialList.vue?vue&type=template&id=3f4548d6&scoped=true"
import script from "./SupplierManageMaterialList.vue?vue&type=script&lang=js"
export * from "./SupplierManageMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4548d6",
  null
  
)

export default component.exports